import React from "react";
import { motion } from "framer-motion";
/* img imports */
import bird1 from "../assets/images/birds/bird-1.png";
import birdCallout from "../assets/images/birds/bird-callout.png";

import { birdMoveAnime } from "../assets/js/animations";

const Birds = () => {
  return (
    <>
      <div className="bird-1-wrapper">
        <img src={bird1} alt="" />
      </div>
      <div className="bird-callout-wrapper">
        <img src={birdCallout} alt="" />
      </div>
      <div className="bird-2-wrapper"></div>
      <motion.div
        className="bird-3-wrapper"
        variants={birdMoveAnime}
        initial="initial"
        animate="animate"
      ></motion.div>
    </>
  );
};

export default Birds;
